import { create } from 'zustand'
import { ErrorType } from '../model/ErrorType'

interface IErrorPopupStore {
  isShow: boolean
  type: ErrorType | null
  okCallback: (() => void) | null
}

export const useErrorPopupStore = create<IErrorPopupStore>(() => ({
  isShow: false,
  type: null,
  okCallback: null,
}))
